import angular from 'angular'

angular.module('nominas.cotizacion')
  .config(($stateProvider) => {
    $stateProvider.state('nominas.cotizacion', {
      url: '/cotizacion/:folio',
      abstract: true,
      resolve: {
        folio: ($stateParams) => $stateParams.folio,
        permisos: (Permisos) => Permisos.modulos({asociar: 'nominas.cotizaciones.asociar'}),
        data: (NominasCotizacion, $stateParams) => NominasCotizacion.get($stateParams['folio']),
      },
      data: {titleProxy: 'nominas.cotizacion.informacion'},
      template: '<nominas-cotizacion data="data" permisos="permisos"></nominas-cotizacion>',
      controller: ($scope, datan, permisos) => {
        $scope.data = data;
        $scope.permisos = permisos;
      },
    });
  });



// WEBPACK FOOTER //
// ./src/nominas/cotizacion/routes/cotizacion.js